import Axios from 'axios';
import qs from 'qs';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL ?? '/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true,
  paramsSerializer: function (params) {
    return qs.stringify(params);
  }
});

// Добавляем interceptor для подстановки access_token
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401 && error.response.config.url !== '/api/v2/auth/me') {
      window.location.href = '/login';
    } else {
      return Promise.reject(error);
    }
  }
);

export default axios;
